import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import Survey from './index.vue';
import SurveyMixins from './mixins';

var PrivateSurveyPage = function (_super) {
  __extends(PrivateSurveyPage, _super);

  function PrivateSurveyPage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.surveyDetails = _this.initDetails();
    _this.surveyId = undefined;
    return _this;
  }

  PrivateSurveyPage.prototype.created = function () {
    this.surveyId = Number(this.$route.query.id);
    this.queryQuestionList();
  };

  PrivateSurveyPage.prototype.queryQuestionList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var params, res, error_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!this.surveyId) {
              this.isFinished = true;
              return [2];
            }

            _a.label = 1;

          case 1:
            _a.trys.push([1, 3,, 4]);

            params = {
              survey_id: this.surveyId
            };
            this.submitLoading = true;
            this.isSuccessLoad = false;
            return [4, this.$api.survey.querySurveyDetails(params)];

          case 2:
            res = _a.sent();
            this.surveyDetails = res.data;
            this.loading = false;
            this.isSuccessLoad = true;
            this.submitLoading = false;
            return [3, 4];

          case 3:
            error_1 = _a.sent();
            this.loading = false;
            this.isSuccessLoad = false;
            this.submitLoading = false;
            return [3, 4];

          case 4:
            return [2];
        }
      });
    });
  };

  PrivateSurveyPage.prototype.handleSubmit = function (params) {
    return __awaiter(this, void 0, void 0, function () {
      var res, error_2;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            params.survey_id = this.surveyDetails.id;
            _a.label = 1;

          case 1:
            _a.trys.push([1, 3,, 4]);

            return [4, this.$api.survey.submitSurvey(params)];

          case 2:
            res = _a.sent();
            this.loading = false;
            this.surveyId = res.data;

            if (!res.data) {
              this.$message.success(this.t('已完成所有问卷，谢谢您的配合。'));
              this.$router.push({
                name: 'PrivateSurveyPage',
                query: {}
              });
              this.isFinished = true;
              return [2];
            }

            if (res.data) {
              this.$message.success(this.t('已完成当前问卷，即将进入下一个问卷。'));
              this.$router.push({
                name: 'PrivateSurveyPage',
                query: {
                  id: this.surveyId && String(this.surveyId) || ''
                }
              });
              this.queryQuestionList();
            }

            return [3, 4];

          case 3:
            error_2 = _a.sent();
            return [3, 4];

          case 4:
            return [2];
        }
      });
    });
  };

  PrivateSurveyPage = __decorate([Component({
    components: {
      Survey: Survey
    }
  })], PrivateSurveyPage);
  return PrivateSurveyPage;
}(Mixins(SurveyMixins));

export default PrivateSurveyPage;